import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../../../../store/store";
import { StoreContextType } from "@/store/types";
import { Button, JourneyMap } from "../../components";
import { useUrlState } from "../../hooks";
import { END_SUB_URL } from "../../../constants";
import { buildJourneyPhases, calculateProgress } from "./utils";
import { BottomBar } from "../../components/bottom-bar";

export function SolutionJourney() {
  const { t } = useTranslation();
  const { navigateToParticipationPage, subStep: challengeId } = useUrlState();
  const [{ publicTest }] = useContext<StoreContextType>(Context as any);

  const challenge = publicTest.solutionTestSets.find(
    set => set._id === challengeId
  );
  const solutionTestSet = publicTest.solutionTestSets[0];
  const journeyPhases = buildJourneyPhases(solutionTestSet, publicTest.entries);
  const progress = calculateProgress(journeyPhases);
  const journeyCompleted = progress === 100;

  function handleJourneyItemClick(itemId: string) {
    navigateToParticipationPage({
      subPage: solutionTestSet._id,
      subStep: itemId,
    });
  }

  function handleNextClick() {
    navigateToParticipationPage({ subPage: END_SUB_URL });
  }

  return (
    <div className="tg_page tg_page-layout tg_topic-selection">
      <div className="tg_main tg_column">
        <div className="tg_topic-selection-header">
          <div>
            {t("frontend.test.solutionJourney.title", "Solution Journey")}
          </div>
          <div>{challenge?.info.name}</div>
        </div>
        <div className="journey-map-wrap">
          <JourneyMap
            phases={journeyPhases}
            progress={progress}
            onPhaseItemClick={handleJourneyItemClick}
          />
        </div>
      </div>

      <div className="tg_column tg_topic-selection-actions">
        {journeyCompleted && (
          <Button next className="button" onClick={handleNextClick}>
            {t("frontend.test.analyticsResults.next", "Next")}
          </Button>
        )}
      </div>
      <BottomBar />
    </div>
  );
}
